import createVueApp from '@phoenix/createVueApp';
import OpeningExceptions from '../components/store/OpeningExceptions.vue';
import Store from '@phoenix/components/Store';

Object.assign(window, {
  Store,
});

const app = createVueApp({}, true);
app.component('OpeningExceptions', OpeningExceptions);
app.mount('#phoenix-store-opening-exceptions');
